<mdb-form-control [formGroup]="formGroup()">
  <input
    mdbInput
    [mdbDatepicker]="datepicker"
    type="text"
    class="form-control"
    [readonly]="true"
    id="{{id()}}"
    formControlName="{{controlName()}}"
    (click)="datepicker.open()"
    style="background-color: initial !important;"
    />
  <label mdbLabel for="{{id()}}" class="form-label">{{label() | translate}} @if (isRequired()) {
    <span>*</span>
  }</label>
  <mdb-datepicker-toggle [mdbDatepicker]="datepicker"></mdb-datepicker-toggle>
  <mdb-datepicker #datepicker
                  [options]="getDatePickerOptions()"
                  [startDay]="1"
                  [confirmDateOnSelect]="true"
                  [format]="environment.displayDateFormat.toLowerCase()"></mdb-datepicker>

  @if (isRequired() && control?.hasError('required') && (control?.dirty || control?.touched)) {
    <mdb-error>{{label() | translate}} {{"VALIDATION.IS_REQUIRED"|translate}}.</mdb-error>
  }
</mdb-form-control>
